import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Center} from '../models/center';

@Injectable({
  providedIn: 'root'
})
export class CenterService {

  constructor(private httpClient: HttpClient) { }

  // [GET] centers
  public getCenters(): Observable<{ [index: string]: any; }> {
    return this.httpClient.get<HttpResponse<object>>
    (environment.api_server + environment.api_endpoints.centers, {
      params: {}, observe: 'response'
    });
  }

  // [GET] center
  public getCenter(id: string): Observable<{ [index: string]: any; }> {
    return this.httpClient.get<HttpResponse<object>>
    (environment.api_server + environment.api_endpoints.centers + '/' + id, {
      params: {}, observe: 'response'
    });
  }

  // [POST] center (Create new center)
  public newCenter(center: Center): Observable<{ [index: string]: any; }> {
    return this.httpClient.post<HttpResponse<object>>
    (environment.api_server + environment.api_endpoints.centers, center, {
      params: {}, observe: 'response',
    })
  }

  // [POST] center (Create new center)
  public updateCenter(centerId: string, center: Center): Observable<{ [index: string]: any; }> {
    return this.httpClient.patch<HttpResponse<object>>
    (environment.api_server + environment.api_endpoints.centers + '/' + centerId, center, {
      params: {}, observe: 'response',
    })
  }

  // [DELETE] center (Delete center)
  public deleteCenter(centerId: string): Observable<{ [index: string]: any; }> {
    return this.httpClient.delete<HttpResponse<object>>
    (environment.api_server + environment.api_endpoints.centers_delete + '/' + centerId, {})
  }
}
